module.exports = __webpack_public_path__ + "images/101_640.jpg";